import styled from "@emotion/styled";
import { SocialIconLinks } from "components/SocialIconLinks/SocialLinks";
import { Text } from "../general/Text";
import { Theme } from "../../styles/theme";

interface SocialsSectionProps {
  theme: Theme;
}

export const SocialsSection: React.FC<SocialsSectionProps> = ({ theme }) => {
  return (
    <Container>
      <Text size="Medium" textStyle="Title">
        Let's jam together
      </Text>
      <Text size="Large" textStyle="Paragraph" color={theme.font.secondary.default}>
        We love your improvisation
      </Text>
      <Buttons>
        <SocialIconLinks gap={"30px"} isColored={true} />
      </Buttons>
    </Container>
  );
};

// Sub-components

export const Container = styled.div`
  background-color: #0f1f21;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 2.3rem 3.8rem;
  @media (max-width: 416px) {
    padding: 1.7rem 3.8rem;
  }
`;

const Buttons = styled.div`
  display: flex;
  justify-content: center;
`;
